<template>
    <div class="modal-container">
        <div class="modal-header">
            <div class="corner-container left">
                <div>
                    <div class="header-label"> <b> {{ headerText }} </b> </div>
                </div>
                <div>
                    <div class="helper-text"> <b>Move-In Date</b> </div>
                    <p class="helper-text-data"> {{ moveInDate }}</p>
                </div>
            </div>
            <div>
                <div class="circle">
                    <button style="width: 100%; height: 100%;" @click="changeAssignee()">
                        {{ unitAddressPreview }}
                    </button>
                </div>
            </div>

            <div class="corner-container right">
                <button class="header-label" @click="$emit('close')">X</button>
                <div>
                    <div class="helper-text"> <b>Status</b> </div>
                    <p class="helper-text-data"> {{ unitStatus }}</p>
                </div>
                <div>
                    <div class="helper-text"> <b>Unit ID</b> </div>
                    <p class="helper-text-data"> {{ unitId }}</p>
                </div>
            </div>

        </div>
        <div class="modal-fields">
            <div class="modal-field">
                <div class="helper-text">Address</div>
                <p class="center-text"> {{ unitAddress }}</p>
            </div>
            <div class="modal-field">
                <div class="helper-text"> Associated Users</div>
                <p v-for="associatedUser in associatedUsers" :key="associatedUser.toString()" class="center-text"> {{ associatedUser.user_first_name }} {{ associatedUser.user_last_name }}: {{ associatedUser.unit_association }}</p>
            </div>
            <!-- <div class="modal-field">
                <div class="helper-text"> Reported By </div>
                <p class="center-text"></p>
            </div>
            <div class="modal-field">
                <div class="helper-text"> Update Log </div>
                <ul style="margin: auto">
            <li class="left-text update-list-item" v-for="update in payload.description.split('.')" :key="update">
              <b></b><br />{{ update }}
            </li>
          </ul> 
            </div> -->
        </div>


        <div class="additional-data">
            <div class="additional-data-item">
                <b>
                    <p>Household Count</p>
                </b>
                <br>
                <p>{{ householdCount }}</p>
            </div>
            <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
            <div class="additional-data-item">
                <b>
                    <p>Number of Pets</p>
                </b>
                <br>
                <p>{{ numberOfPets }}</p>
            </div>
            <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
            <div class="additional-data-item">
                <b>
                    <p>Number of Vehicles</p>
                </b>
                <br>
                <p>{{ numberOfVehicles }}</p>
            </div>
            <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
            <div class="additional-data-item">
                <b>
                    <p>Guests Invited</p>
                </b>
                <br>
                <p>{{ guestsInvited }}</p>
            </div>
        </div>


        <div v-if="role == 'admin'">
            <div class="button-container">
                <button class="action-button" @click="addComment()">Update Unit</button>
                <button class="action-button suspended-button" @click="updateIncident()">Log Incident</button>
            </div>
            <div class="button-container">
                <button class="validate button" @click="suspendUser()">Send Message</button>
            </div>
        </div>
        <div v-else>
            <div class="button-container">
                <button class="action-button" @click="editUser()">Edit User</button>
                <button class="action-button" @click="addSecondaryUser()">Add Secondary User</button>
            </div>
        </div>

    </div>
</template>

<script>
import * as Constants from '../../js/constants'
const NAME = Constants.UNIT_MODAL

export default {
    modalName: NAME,
    components: {
    },
    props: ["organizationData", "userData", "unitData"],
    watch: {
        unitData: function (newVal) {
            console.log("new unit data val", newVal)
        }
    },
    data() {
        return {
            modalName: NAME,
            suspended: false,
            inactive: true,
            showId: false,
            date: new Date(),
            payload: {},
        }
    },
    methods: {
        show() {
            this.$modal.show();
        },
        close() {
            this.$modal.hide();
        },
        showKey() {
            console.log("show key...")
        },
        showIncidents() {
            console.log("show incidents...")
        },
        edit() {
            console.log("edit mode!")
        },
        editUser() {
            console.log("edit user...")
        },
        addSecondaryUser() {
            console.log("add user...")
        },
        suspendUser() {
            console.log("suspend user...")
        },
        showUserId() {
            this.showId = true
        },
        hideUserId() {
            this.showId = false
        },
        uploadAttachment() {
            alert("Upload Attachment")
        },
        changeAssignee() {
            alert("Change Assignee")
        },
        addComment() {
            alert("Add Comment")

        },
        updateIncident() {
            alert("Update Incident")

        },
        getMappedName(id) {
            return this.$organizationMap[id] ?? id
        }
    },
    computed: {
        headerText: function () {
            return `${this.getMappedName(this.$props.organizationData.organization_id)}`
        },
        circleText: function () {
            return `${this.payload.visitor_first_name[0]}${this.payload.visitor_last_name[0]}`
        },
        moveInDate: function () {
            return `${new Date(this.$props.unitData.unit_move_in_date).toLocaleDateString()}`
        },
        unitStatus: function () {
            return this.$props.unitData.current_status
        },
        visitorType: function () {
            return this.payload.visitor_relationship
        },
        unitId: function () {
            return this.$props.unitData.unit_id
        },
        unitAddress: function () {
            return this.$props.unitData.unit_full_address
        },
        unitAddressPreview: function () {
            let address = this.$props.unitData.unit_full_address
            return this.$props.unitData.unit_full_address.substring(0, address.indexOf(' '))
        },
        householdCount: function () {
            return `2`

        },
        numberOfPets: function () {
            return `2`

        },
        numberOfVehicles: function () {
            return `2`

        },
        guestsInvited: function () {
            return `2`
        },
        role: function () {
            return this.$props.userData['custom:cts_role']
        },
        associatedUsers: function() {
            if(this.$props.unitData.associated_users.length > 0 && this.$props.unitData.associated_users[0] != null){
                return this.$props.unitData.associated_users
            }
            return null
        }
    },
    created() { },
    mounted() {
        console.log("Unit Modal", JSON.parse(JSON.stringify(this.$props)))

    }
}
</script>

<style></style>
